import styled from "styled-components";
import { bodyColor } from "../../../../../../config/constants";
import { inputCheckboxIndex } from "../../../../../../config/zIndex";

export const ProtocolLevelDiv = styled.div`
  margin-bottom: 10px;
  width: 55%;
  display: flex;
  flex-direction: column;
`;
export const HeaderDiv = styled.div`
  padding-right: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ProtocolLevelAlignerDiv = styled.div`
  margin: 5px 0;
  padding-left: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ControlText = styled.p`
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "14px")};
  font-weight: bold;
`;
export const LevelCheckboxDiv = styled.div`
  display: flex;
  align-items: center;
`;
export const InputCheckboxDiv = styled.div`
  margin-right: 10px;
  width: 23px;
  height: 23px;
  position: relative;
`;
export const InputCheckbox = styled.input`
  width: 23px;
  height: 23px;
  opacity: 0;
  position: absolute;
  z-index: ${inputCheckboxIndex};
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const VerifyCheckboxImg = styled.img`
  width: 23px;
  height: 23px;
  position: absolute;
`;
export const DurationSelect = styled.select`
  padding-left: 15px;
  width: 75px;
  height: 30px;
  font-size: 14px;
  color: #000;
  border: 1px solid ${bodyColor};
  border-radius: 5px;
  appearance: none;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
